import { Box, Heading } from "@chakra-ui/layout";
import { Typography, ContentfulRichText } from "components";
import { ILegalArticle } from "interfaces/legal-guide-interfaces";
import { NextSeo } from "next-seo";
import { LegalArticleTableOfContents } from "./LegalArticleTableOfContents";

interface ILegalArticleProps {
  article: ILegalArticle;
}

export const LegalArticle = ({ article }: ILegalArticleProps) => {
  return (
    <>
      <NextSeo title={`LeadPro – ${article.name}`} />
      <Box display={"flex"} flexDirection={{ base: "column", lg: "row" }}>
        <Box
          flex={{ base: 0, lg: 1 }}
          p={{ base: 1, lg: 10 }}
          mr={{ base: 0, lg: 12 }}
          order={{ base: 2, lg: 0 }}
        >
          <Heading mb={12} fontSize="4xl" fontWeight={500}>
            {article.name}
          </Heading>
          <Typography>
            <ContentfulRichText document={article.body} />
          </Typography>
        </Box>
        <Box order={{ base: 1, lg: 0 }}>
          <LegalArticleTableOfContents article={article.body} />
        </Box>
      </Box>
    </>
  );
};
